import type { ReactNode } from 'react';
import * as RadixTabs from '@radix-ui/react-tabs';
import './Tabs.css';

export interface TabItem {
  value: string;
  label: string;
  /** A small count beside the label, for example open exceptions. */
  count?: number;
  content: ReactNode;
}

export interface TabsProps {
  items: TabItem[];
  value: string;
  onValueChange: (value: string) => void;
  /** Spoken name for the tab list. */
  label: string;
}

/** Radix Tabs; the value lives in the URL where the screen owns view state. */
export function Tabs({ items, value, onValueChange, label }: TabsProps): ReactNode {
  return (
    <RadixTabs.Root value={value} onValueChange={onValueChange} className="pui-tabs">
      <RadixTabs.List className="pui-tabs__list" aria-label={label}>
        {items.map((t) => (
          <RadixTabs.Trigger key={t.value} value={t.value} className="pui-tabs__tab">
            {t.label}
            {t.count !== undefined && t.count > 0 ? (
              <span className="pui-tabs__count">{t.count}</span>
            ) : null}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {items.map((t) => (
        <RadixTabs.Content key={t.value} value={t.value} className="pui-tabs__panel">
          {t.content}
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
  );
}
